export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/lead_generation.6100b9e.svg";